module.exports = __webpack_public_path__ + "img/docs-image-02.660b07dc.png";